var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DashboardLayout',[_c('RolesBody',{attrs:{"admin":_vm.admin.adminUsers,"roles":_vm.admin.roles,"loading":_vm.admin.loading,"groups":_vm.admin.groups,"rolespermission":_vm.admin.rolespermission,"grouptypes":_vm.admin.grouptypes,"permissions":_vm.admin.permissions}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }